import { EnvironmentsInterface } from '@core-utils';

export const environment: EnvironmentsInterface = {
  production: false,
  api: 'https://api-dev.2xpoints.com/api/v1/',
  name: 'DEV',
  helpHeroAppId: 'Aa7eTXxk64',
  keycloak: {
    production: true,
    oauthServerHost: 'https://auth-dev.rewardsandpoints.com',
    oauthRealm: 'mjpromo-realm',
    oauthClientId: 'frontend',
    superAdminRole: 'super_user',
    responseType: 'code',
    scope: 'openid profile email',
  },
};
